"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconGlobe = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var icon_1 = require("./icon");
exports.IconGlobe = react_1.default.forwardRef(function (props, ref) { return ((0, jsx_runtime_1.jsxs)(icon_1.Icon, __assign({ viewBox: "0 0 24 24", ref: ref, "data-name": "IconGlobe" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 0h24v24H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M12 2a10 10 0 1010 10A10 10 0 0012 2zm.75 5.25V4.58a10 10 0 012.06 2.67zm2.68 1.5a9.89 9.89 0 01.49 2.5h-3.17v-2.5zm-4.18-4.17v2.67H9.19a10 10 0 012.06-2.67zm0 4.17v2.5H8.08a9.89 9.89 0 01.49-2.5zm-4.67 2.5H4a7.83 7.83 0 01.66-2.5H7a11.46 11.46 0 00-.42 2.5zM4 12.75h2.58a11.46 11.46 0 00.42 2.5H4.7a7.83 7.83 0 01-.7-2.5zm4 0h3.17v2.5h-2.6a9.89 9.89 0 01-.49-2.5zm3.17 4v2.67a10 10 0 01-2.06-2.67zm1.5 2.67v-2.67h2.06a10 10 0 01-1.98 2.67zm0-4.17v-2.5h3.17a9.89 9.89 0 01-.49 2.5zm4.67-2.5H20a7.83 7.83 0 01-.66 2.5H17a11.46 11.46 0 00.42-2.5zm0-1.5a11.46 11.46 0 00-.34-2.5h2.3a7.83 7.83 0 01.66 2.5zm1-4h-2a11.81 11.81 0 00-1.72-2.76 8 8 0 013.8 2.76zM9.26 4.49a11.81 11.81 0 00-1.72 2.76h-2a8 8 0 013.72-2.76zM5.58 16.75h2a11.81 11.81 0 001.72 2.76 8 8 0 01-3.72-2.76zm9.16 2.76a11.81 11.81 0 001.72-2.76h2a8 8 0 01-3.72 2.76z" })] }))); });
exports.IconGlobe.displayName = 'IconGlobe';
exports.default = exports.IconGlobe;
